import React from "react"

export default function AndroidIcon() {
  return (
    <svg
      width="49"
      height="60"
      viewBox="0 0 49 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="white-fill"
        d="M45.3442 41.3897C43.5412 41.3897 41.9385 39.7865 41.9385 37.9828V25.1569C41.9385 23.3532 43.5412 21.75 45.3442 21.75C47.1473 21.75 48.75 23.3532 48.75 25.1569V37.9828C48.75 39.7865 47.3476 41.3897 45.3442 41.3897Z"
        fill="#4996FF"
      />
      <path
        className="white-fill"
        d="M29.2545 60C27.4247 60 25.7982 58.4062 25.7982 56.6133V50.6367H22.7485V56.6133C22.7485 58.4062 21.122 60 19.2922 60C17.4623 60 15.8358 58.4062 15.8358 56.6133V50.6367H12.3795C9.73645 50.6367 7.5 48.4453 7.5 45.8555V21.75H40.8434H41.25C41.25 21.9492 41.25 22.5469 41.25 22.5469V46.0547C41.25 48.6445 39.0135 50.8359 36.3705 50.8359H32.9142V56.8125C32.7108 58.6055 31.2876 60 29.2545 60Z"
        fill="#4996FF"
      />
      <path
        className="white-fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.81421 20.52H40.6699C40.6699 15.3094 37.4644 9.29727 32.8566 6.09078L35.0604 1.48146C35.2607 1.08065 35.0604 0.679836 34.6597 0.479431C34.259 0.279025 33.8583 0.47943 33.658 0.880241L31.6546 5.28916C29.2505 4.08673 26.6461 3.48551 24.0417 3.48551C22.0383 3.48551 19.6342 3.88632 17.4305 4.88835L15.4271 0.479431C15.2268 0.0786197 14.8261 -0.121785 14.4254 0.0786201C14.0247 0.279026 13.8244 0.679837 14.0247 1.08065L16.2285 5.48957C11.0196 8.49565 7.81421 14.107 7.81421 19.7184V20.52ZM17.8299 13.105C17.0285 13.105 16.4275 12.5038 16.4275 11.7022C16.4275 10.9005 17.0285 10.2993 17.8299 10.2993C18.6312 10.2993 19.2322 10.9005 19.2322 11.7022C19.2322 12.5038 18.6312 13.105 17.8299 13.105ZM29.8511 13.105C29.0497 13.105 28.4487 12.5038 28.4487 11.7022C28.4487 10.9005 29.0497 10.2993 29.8511 10.2993C30.6524 10.2993 31.2535 10.9005 31.2535 11.7022C31.2535 12.5038 30.6524 13.105 29.8511 13.105Z"
        fill="#4996FF"
      />
      <path
        className="white-fill"
        d="M3.37501 41.25C1.58824 41.25 0 39.6582 0 37.8673V25.1327C0 23.3418 1.58824 21.75 3.37501 21.75C5.16177 21.75 6.75 23.3418 6.75 25.1327V37.8673C6.75 39.6582 5.16177 41.25 3.37501 41.25Z"
        fill="#4996FF"
      />
    </svg>
  )
}
